import React from "react";
import { connect } from "react-redux";
import { Navigate } from "react-router-dom";

import { auth } from "services/firebase";   // only auth comes from your file
import { signOut } from "firebase/auth";   // signOut comes from Firebase SDK
import { getIsSignedIn } from "store/reducers";
import { resetState } from "store/actions/profile";
import { authResetState } from "store/actions/auth";

class SignOut extends React.Component {
  componentDidMount() {
    // Sign out user
    signOut(auth).then(() => { 
    this.props.authResetState();
    this.props.resetState();
    if(!this.props.signedIn){
      this.props.navigate("/auth/signin");
    }
    }).then(() => {
      fetch(`${process.env.REACT_APP_WORDPRESS_URL}/wp-json/firebase/v1/signout`, {
        method: "POST",
        credentials: "include",
        headers: {
            "Content-Type": "application/json",
        },
        timeout: 10000,
        body: JSON.stringify({ 
            redirect: process.env.REACT_APP_WORDPRESS_URL
        })
    })
    }).catch((error) => console.log(error));
  }

  render() {
    const { signedIn } = this.props;
    // console.log("signedIn,",signedIn)
    // if (!signedIn) {
    //   return <Navigate to="/auth/signin" replace />; 
    // }

    return <h1>Signing you out now...</h1>;
  }
}

const mapStateToProps = (state) => ({
  signedIn: getIsSignedIn(state),
});

const mapDispatchToProps = { resetState ,authResetState};

export default connect(mapStateToProps, mapDispatchToProps)(SignOut);
